import React from 'react'
import styled from 'styled-components'

import { FONTS } from '../../../constants'
import ArrowUp from '../../../static/images/arrow-up-black.svg'
import ArrowDown from '../../../static/images/arrow-down-black.svg'

export const GroupHeaderRow = ({ teamCalendar, isHidden, group, onGroupHeaderClick }) => {
  return (
    <HeaderRowGroup style={ { height: 50, flex: '0 0 50', display: 'flex', flexDirection: 'row' } }>
      {
        teamCalendar &&
          <CellLeftColGroup
            style={ { backgroundColor: '#FFFFFF', width: 200, overflow: 'hidden', cursor: 'pointer', borderRight: '1px solid #EAEAEA' } }
            onClick={ () => onGroupHeaderClick(group) }
          >
            <b>{group.label} {isHidden ? <Icon src={ ArrowUp } alt='up' /> : <Icon src={ ArrowDown } alt='down' /> }</b>
          </CellLeftColGroup >
      }
      <Cell style={ { flex: 1, backgroundColor: '#E7E7E7' } } />
    </HeaderRowGroup>
  )
}

const HeaderRowGroup = styled.div`
  background-color: #FFFFFF;
  border: solid #EAEAEA;
  border-width: 0px 0px 1px 0px;
`

const CellLeftColGroup = styled.div`
  border: solid #EAEAEA;
  border-width: 0px 1px 0px 0px;
  display: flex;
  align-items: center;
  padding-left: 1% ;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
`

const Cell = styled.div`
  border: solid #EAEAEA;
  border-width: 0px 1px 0px 0px;
`

const Icon = styled.img`
  width: 10px;
  height: 10px;
  margin-left: 10px;
`



// WEBPACK FOOTER //
// ./src/components/calendar/vertical-table/group-header-row.js